export default function prompt(e) {
  e.preventDefault();
  e.returnValue = "";
}
